import { render, staticRenderFns } from "./storeList.vue?vue&type=template&id=2834b370&scoped=true&"
import script from "./storeList.vue?vue&type=script&lang=js&"
export * from "./storeList.vue?vue&type=script&lang=js&"
import style0 from "./storeList.vue?vue&type=style&index=0&id=2834b370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2834b370",
  null
  
)

export default component.exports